<nb-card *ngIf="loading === false">
    <nb-card-header>{{header}}</nb-card-header>
    <nb-card-body>{{body}}</nb-card-body>
    <nb-card-footer>
        <div *ngIf="dialogType && dialogType === 'info'; else elseBlock">
            <div class="d-flex justify-content-center">
                <button nbButton status="warning" (click)="proceed('OK')" class="mr-3">OK</button>
              </div>      
        </div>
          <ng-template #elseBlock>
            <button nbButton status="danger" (click)="proceed('YES')" class="mr-3">Yes</button>
        <button nbButton status="basic" (click)="proceed('NO')">No</button>
          </ng-template>
    </nb-card-footer>
</nb-card>